import React from 'react';
import { CircleDot } from 'lucide-react';
import styles from './StatusPill.module.scss';
import type { StatusKey } from '../../types';

interface StatusStyle {
  label: string;
  color: string;
  bg: string;
}

export const STATUS_STYLES: Record<StatusKey, StatusStyle> = {
  paid: { label: 'Paid', color: '#13804a', bg: '#e7f6ee' },
  pending: { label: 'Pending', color: '#97650b', bg: '#fbf1df' },
  overdue: { label: 'Overdue', color: '#c23b2e', bg: '#fdedeb' },
  open: { label: 'Open', color: '#13804a', bg: '#e7f6ee' },
  closed: { label: 'Closed', color: '#6e6c93', bg: '#efeef7' },
  active: { label: 'Active', color: '#13804a', bg: '#e7f6ee' },
};

interface StatusPillProps {
  status: StatusKey;
}

export function StatusPill({ status }: StatusPillProps) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.active;
  return (
    // Shape/spacing lives in SCSS; color and background are the only
    // two values that vary per status, so they're set here as CSS
    // custom properties consumed by the class in StatusPill.module.scss.
    <span
      className={styles.pill}
      style={{ ['--pill-color' as any]: s.color, ['--pill-bg' as any]: s.bg }}
    >
      <CircleDot size={10} strokeWidth={3} />
      {s.label}
    </span>
  );
}
